import script from "./upgrade-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./upgrade-settings.vue?vue&type=script&setup=true&lang=ts"

import "./upgrade-settings.vue?vue&type=style&index=0&id=5afe5a24&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afe5a24"]])

export default __exports__